<template>
	<div :class="['im-body', $store.state.setImObj.pifu, {'zuidahua': $store.state.setImObj.zuidahua}]" @click="hidePanel">
		<section class="im-main">
			<audio id="adobibi" src="/static/file/bibi.wav" preload="true"></audio>
			<headTpl @closeSession="closeSession"></headTpl>
			<div class="im-record">
				<conversationContainer ref="conversationBox"></conversationContainer>
				<asideContainer></asideContainer>
				<msgListContainer @closeSession="closeSession"></msgListContainer>
			</div>
		</section>
		<notifyMe></notifyMe>
	</div>
</template>

<script>
import notifyMe from '../components/notifyMe.vue'
import headTpl from './head/headTpl.vue'
import conversationContainer from './conversation/conversationContainer.vue'
import msgListContainer from './msgList/msgListContainer.vue'
import asideContainer from './aside/asideContainer.vue'
import Logan from 'logan-web';
export default {
	name: 'imMain',
	data () {
		return {
			kSwitchSessionInterval: null
		}
	},
	components: {
		'notifyMe': notifyMe,
		'headTpl': headTpl,
		'conversationContainer': conversationContainer,
		'msgListContainer': msgListContainer,
		'asideContainer': asideContainer
	},
	computed: {
		conversationList () {
			return this.$store.state.conversationList;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		},
		shopList () {
			return this.$store.state.shopList;
		}
	},
	created () {
		var self = this;
		window.onkeydown = function(e){
			self.shortcutKey(e);
		}

		Logan.log('Page init', 1);

		try {
			window.indexedDB.deleteDatabase(TJ_DB.DB_Name);
		} catch(e){
			console.log('删除数据库失败');
		}

		if(window.Notification && Notification.permission !== "denied") {
			Notification.requestPermission(status => {
				console.log(status === 'granted' ? '用户同意接收通知' : '已拒绝接收通知');
			});
		}
			
		TJ_DB.openDB(function() {
			self.getUserInfo();
		});

		document.addEventListener('click', () => {
			window.userClick = true
		})
	},
	watch: {
		currentConversation: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id) return;
				let index = this.conversationList.findIndex(o => o.id == now.id);

				this.$store.commit('changeKeyHover', index);
			}
		}
	},
	methods: {
		// 关闭会话
		closeSession (sessionId, needRts) {
			var self = this;

			self.$refs.conversationBox.$refs.conversationList.closeSession(sessionId, needRts);
		},

		// 获取用户信息
		getUserInfo () {
			var self = this;

			self.$axios.post(API_ROOT.url + '/CustomerUserApi.getUserInfo').then(result => {
				if (result.status) {
					self.$store.commit('changeUserInfo', result.data);
				} else {
					self.$alert('获取用户信息失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取用户信息失败，错误码(' + response + ')');
			})
		},

		// 点击空白处，隐藏面板
		hidePanel (e) {
			var self = this,
				classArr = e.target.classList;

			// 隐藏设置框
			var setImPanel = document.getElementsByClassName("im-set-im-form")[0];
			if (setImPanel && !setImPanel.contains(e.target) && !e.target.classList.contains('js-set-im-btn')) {
				self.$store.commit('changeShowSetImForm', false);
			}

			// 隐藏会话排序框
			if (e.target.className != 'js-conversation-sort-btn') {
				self.$store.commit('changeShowSortBox', false);
			}

			// 隐藏表情框
			var emotionsContainer = document.getElementsByClassName("js-emotions-container")[0];
			if (emotionsContainer && !emotionsContainer.contains(e.target) && !e.target.classList.contains('js-open-emotions-btn')) {
				self.$store.commit('changeShowEmotions', false);
			}

			// 隐藏旺旺转接类型列表
			var transferTypeList = document.getElementsByClassName("js-transfer-type-list")[0];
			if (!transferTypeList.contains(e.target) && !e.target.classList.contains('js-transfer-btn-list')) {
				self.$store.commit('changeShowTransferTypeList', false);
			}

			// 隐藏转接列表
			var transferList = document.getElementsByClassName("js-transfer-list")[0];
			if (transferList && !transferList.contains(e.target) && !e.target.classList.contains('js-transfer-btn-list')) {
				self.$store.commit('changeShowTransferList', false);
			}

			// 隐藏AI智能辅助框
			var aiPushAnswer = document.getElementsByClassName("ai-push-answer-box")[0];
			if (aiPushAnswer && !aiPushAnswer.contains(e.target) && !e.target.classList.contains('msg-box-text')) {
				self.$store.commit('changeShowAiAnswer', false);
			}

			// 隐藏搜索联系人列表
			var searchConversationList = document.getElementsByClassName("js-search-conversation")[0];
			if (searchConversationList && !searchConversationList.contains(e.target)) {
				self.$store.commit('changeShowSearchConversationList', false);
			}
		},

		// 快捷键定义
		shortcutKey (e) {
			var self = this;

			// 关闭当前会话(Esc)
			if (e.keyCode == 27 && self.currentConversation.id) {
				e.stopPropagation();
				e.preventDefault();
				self.closeSession(self.currentConversation.id, true);
				return;
			}

			var temp = !$('.ima_textarea').data('showatwholist') && !$(e.target).closest('.el-dialog__wrapper').length && !$(e.target).closest('.disable-shortcut-key').length
			// 查看上一个会话(↑)
			if (e.keyCode == 38 && temp) {
				clickConversation(false, e);
				return;
			}

			// 查看下一个会话(↓)
			if (e.keyCode == 40 && temp) {
				clickConversation(true, e);
				return;
			}

			// 触发第一个订单的复制功能(Alt + q)
			if (e.keyCode == 81 && e.altKey) {
				var orderActive = $('.js-ww-order-btn').closest('a').hasClass('active'),
					$copy = $('.ww-userinfo-body .orders dl:first').find('.js-copy-order');

				if (!orderActive || !$copy.length) return;
				e.stopPropagation();
				e.preventDefault();
				$copy.trigger('click');
				return;
			}

			// 触发第一个展开订单的备注按钮(Alt + w)
			if (e.keyCode == 87 && e.altKey) {
				var orderActive = $('.js-ww-order-btn').closest('a').hasClass('active'),
					$remark = $('.ww-userinfo-body .orders dl.open').eq(0).find('.modify-mark');

				if (!orderActive || !$remark.length) return;
				e.stopPropagation();
				e.preventDefault();
				$remark.trigger('click');
				return;
			}

			// 快捷键切换店铺(Alt + 1……9)
			if ((e.keyCode == 49 || e.keyCode == 97) && e.altKey) {
				clickShop(0, e);
				return;
			}
			if ((e.keyCode == 50 || e.keyCode == 98) && e.altKey) {
				clickShop(1, e);
				return;
			}
			if ((e.keyCode == 51 || e.keyCode == 99) && e.altKey) {
				clickShop(2, e);
				return;
			}
			if ((e.keyCode == 52 || e.keyCode == 100) && e.altKey) {
				clickShop(3, e);
				return;
			}
			if ((e.keyCode == 53 || e.keyCode == 101) && e.altKey) {
				clickShop(4, e);
				return;
			}
			if ((e.keyCode == 54 || e.keyCode == 102) && e.altKey) {
				clickShop(5, e);
				return;
			}
			if ((e.keyCode == 55 || e.keyCode == 103) && e.altKey) {
				clickShop(6, e);
				return;
			}
			if ((e.keyCode == 56 || e.keyCode == 104) && e.altKey) {
				clickShop(7, e);
				return;
			}
			if ((e.keyCode == 57 || e.keyCode == 105) && e.altKey) {
				clickShop(8, e);
				return;
			}

			// 快捷键切换店铺
			function clickShop(index, e) {
				if (self.shopList.length > (index + 1)) return;
				e.stopPropagation();
				e.preventDefault();
				self.$store.commit('changeCurrentShop', self.shopList[index]);
			}

			// 快捷键切换会话
			function clickConversation(next, e) {
				var sign = false;
				if (self.$store.state.keyHover < 0) {
					self.$store.commit('changeKeyHover', $('.conversation-list .active').index());
				}
				
				if (next) {
					var temp = self.$store.state.keyHover + 1;
					if (temp < self.conversationList.length) {
						self.$store.commit('changeKeyHover', temp);
						sign = true;
					}
				} else {
					var temp = self.$store.state.keyHover - 1;
					if (temp >= 0) {
						self.$store.commit('changeKeyHover', temp);
						sign = true;
					}
				}

				if (!sign) return;
				e.stopPropagation();
				e.preventDefault();
				if (self.kSwitchSessionInterval) clearTimeout(self.kSwitchSessionInterval);

				self.kSwitchSessionInterval = setTimeout(function() {
					var index = self.$store.state.keyHover;
					if (index >= 0 && self.conversationList[index].id && self.conversationList[index].id != self.currentConversation.id) {
						self.$store.commit('changeCurrentConversation', JSON.parse(JSON.stringify(self.conversationList[index])));
					}
					self.kSwitchSessionInterval = null;
					self.$store.commit('changeKeyHover', -1);
				}, 500);
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/imMain.vue